import { TamarraParityProvider } from './tamarraParityContext'
import './tamarraParity.css'

/**
 * Scopes Tamarra Trend design + booking steps to opted-in surfaces
 * (standalone recherche + selected moteur tabs such as a_la_carte).
 */
const TamarraParityShell = ({ children }) => (
  <TamarraParityProvider value>
    <div className="tamarra-parity" data-tamarra-parity="true">
      {children}
    </div>
  </TamarraParityProvider>
)

export default TamarraParityShell
